import generalSection from "../_section/section.class";
import {adminExistingMpiPolicyUpload, userExistingMpiPolicyUpload} from "./upload";
import DataForm from "./DataForm";
import dayjs from "dayjs";
import problem from "../_section/section-problem.class";

export class userExistingMpiPolicySection extends generalSection {
    constructor(request, mortgage, props, statementUploadFactory = null) {
        super(request, mortgage, props, statementUploadFactory ?? userExistingMpiPolicyUpload);
        // Add missing date error

    }
}

export class adminExistingMpiPolicySection extends userExistingMpiPolicySection {
    constructor(request, mortgage, props) {
        super(request, mortgage, props, adminExistingMpiPolicyUpload);
        this.DataForm = DataForm
        this.sortByDateProp('endDate')
        this.setProblems(this.getProblems())
    }


    getProblems() {
        /*
    drawdown date is the reference date for MPI policies
    calc orig start date + term to get end date
    check if end date < drawdown date + loan term by more than 1.5 months
     */
        const problems = this.problemsList.universalVerifiedUploadProblems();


        if (!problems.length) {
            const sub = this.mortgage.activeSubmission
            const ourLoan = sub.finalLoan || sub.aipLoan ||sub.provisionalLoan
            const ourTermYears = sub?.aipTerm || sub?.finalTerm || sub?.provisionalTerm || this.mortgage.requirement.loanTerm
            const ourTermMonths = sub?.aipTermPlusMonths || sub?.finalTermPlusMonths || sub?.provisionalTermPlusMonths || 0
            const ourEndDate = sub.drawdownDate ? dayjs(sub.drawdownDate).add(ourTermYears || 0, 'year').add(ourTermMonths || 0, 'month') : null
            const upload = this.activeUpload = this.uploads.find(u => u.allValuesAnswered && u.isVerifiable)
            const coverAmount = upload?.values?.coverAmount
            const endDate = upload.values?.endDate
            if (ourLoan > coverAmount) {
                problems.push(new problem({
                    type: 'DATA',
                    title: 'Insufficient Cover Amount',
                    reason: 'The cover amount on the existing MPI policy is less than the loan amount',
                    message: `The cover amount on the existing MPI policy is ${coverAmount?.toLocaleString() || '0'}, which is less than the loan amount of ${ourLoan?.toLocaleString() || '0'}.`,
                    uploadID: upload.id,
                }))
            }
            if (ourEndDate && endDate) {
                const bufferDate = ourEndDate.subtract(1.5, 'month')
                const monthDifference = endDate.diff(bufferDate, 'month', true)
                if (endDate.isBefore(bufferDate, 'day')) {
                    problems.push(new problem({
                        type: 'DATA',
                        title: 'Insufficient Policy Term',
                        reason: 'The end date on the existing MPI policy is before the required end date',
                        message: `The end date on the existing MPI policy is short by approximately ${Math.ceil(-monthDifference)} month(s). `,
                        uploadID: upload.id,
                    }))
                }
            }


            // const noRequired = this.numberOfForm11Needed()
            // const thisYear = Number(dayjs().format("YYYY"))
            // const yearsRequired = Array.from({length: noRequired}, (_, i) => (thisYear - (i + 1)).toString())
            // const yearsHave = this.uploads.filter(u => u.isActive && u.isVerifiable && u.allValuesAnswered).map(u => u.values.year)
            //
            // const missingFromRequired = yearsRequired.filter(item => !yearsHave.includes(item))
            // if (missingFromRequired.length > 0) {
            //     problems.push(new problem({
            //         type: 'BUNDLE',
            //         title: 'Missing Form 11',
            //         reason: 'Missing Form 11 for the current year and previous years',
            //         message: `Missing Form 11 for ${missingFromRequired.join(', ')}`
            //     }))
            // }

        }
        return problems;
    }

    getSectionSummary = () => {
        return [
            {
                name: this.personalTitle,
                tags: [{
                    name: 'End Date',
                    value: this.activeUpload?.values?.endDate?.format('D MMM YYYY') || 'Not Provided'
                }, {
                    name: 'Cover Amount',
                    value: this.activeUpload?.values?.coverAmount?.toLocaleString() || 'Not Provided'
                }]
            }
        ]
    }
}